import { useEffect, useState } from 'react';
import Markdown from './Markdown';

// The site's words live in backend/content/*.md: served at /api/content/<name>.md, read by
// these pages and by machines alike. A page asks for its copy and gets it split into
// sections at its headings, so it can lay sections out and put live data between them.

const cache = {};

export function useCopy(name) {
  const [text, setText] = useState(cache[name] ?? null);
  useEffect(() => {
    if (cache[name]) return;
    fetch(`/api/content/${name}.md`)
      .then((r) => (r.ok ? r.text() : ''))
      .then((t) => { cache[name] = t; setText(t); })
      .catch(() => setText(''));
  }, [name]);
  return text;
}

/** `# title` and `## heading` sections, in order: [{level, title, body}] (level 0 is any text before the first heading) */
export function sections(text) {
  const out = [];
  let current = { level: 0, title: '', body: [] };
  for (const line of (text || '').split('\n')) {
    const m = line.match(/^(#{1,2})\s+(.*)$/);
    if (m) {
      out.push(current);
      current = { level: m[1].length, title: m[2].trim(), body: [] };
    } else {
      current.body.push(line);
    }
  }
  out.push(current);
  return out.map((s) => ({ ...s, body: s.body.join('\n').trim() })).filter((s) => s.title || s.body);
}

export function find(parts, title) {
  return parts.find((s) => s.title.toLowerCase() === title.toLowerCase());
}

/** markdown in the site's reading style */
export function Prose({ children, className = '' }) {
  if (!children) return null;
  return (
    <div className={`copy-prose space-y-4 text-[#aaaaaa] leading-relaxed ${className}`}>
      <Markdown>{children}</Markdown>
    </div>
  );
}
